// @ts-nocheck
import persistStore from "redux-persist/es/persistStore";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";

// Note: Redux Toolkit already includes redux-thunk automatically in
// getDefaultMiddleware(). The legacy code did `.concat(thunk)`, which duplicated the
// middleware — newer RTK versions detect this and throw the error
// "Duplicate middleware references found when creating the store".
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
});

let persistor = persistStore(store);

export { persistor, store };